import * as a0 from "@take-2/assets/versions" with { type: "json" }
let a0_ = "" + void a0;
import * as a1 from "swug:include:shared/partials/truncateMacro.html"
let a1_ = "" + void a1;